/* unplugin-vue-components disabled */import { render } from "./right-controls.vue?vue&type=template&id=a11e78dc&scoped=true"
import script from "./right-controls.vue?vue&type=script&lang=js"
export * from "./right-controls.vue?vue&type=script&lang=js"

import "./right-controls.vue?vue&type=style&index=0&id=a11e78dc&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a11e78dc"],['__file',"src/components/chat-input-v2/right-controls.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a11e78dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a11e78dc', __exports__)) {
    api.reload('a11e78dc', __exports__)
  }
  
  module.hot.accept("./right-controls.vue?vue&type=template&id=a11e78dc&scoped=true", () => {
    api.rerender('a11e78dc', render)
  })

}


export default __exports__